/**
 * Warwick Design System - Color Tokens
 * Self-contained color palette with semantic naming
 */

// Base color palette
const palette = {
  purple: {
    primary: '#403A60', // Main text and UI elements
  },
  gold: {
    primary: '#C4AA6F', // Accent color for highlights and selections
  },
  white: {
    pure: '#ffffff', // Pure white
    alpha94: 'rgba(255, 255, 255, 0.94)', // Header bar background
    alpha84: 'rgba(255, 255, 255, 0.84)', // Left sidebar background
    alpha65: 'rgba(255, 255, 255, 0.60)', // carousel container
    alpha75: 'rgba(255, 255, 255, 0.75)', // carousel container
  },
  red: {
    notification: '#E60E0E', // Notification dots
  },
  // Legacy colors from current variables - keeping for transition
  background: {
    light1: '#FAF8F6',
    light2: '#F4EEE7',
    light3: '#F5F5F5',
  },
  border: {
    light1: '#F1EAE4',
    light2: '#E6E1DB',
    accent: '#C4AA6F',
  },
};

// Semantic color tokens
export const colors = {
  // Text colors
  text: {
    primary: palette.purple.primary, // #403A60 - Main text
    accent: palette.gold.primary, // #C4AA6F - QR code text, accents
    onDark: palette.white.pure, // #ffffff - Text on dark backgrounds
    inverse: palette.white.pure, // #ffffff - White text
  },

  // Surface/background colors
  surface: {
    headerBar: palette.white.alpha94, // Header bar background
    sidebar: palette.white.alpha84, // Left sidebar background
    container: palette.white.alpha65,
    card: palette.white.pure, // Card backgrounds
    primary: palette.purple.primary, // Primary surface color
    content: palette.white.alpha75,
    // Legacy surfaces for transition
    light1: palette.background.light1,
    light2: palette.background.light2,
    light3: palette.background.light3,
  },

  // Interactive elements
  interactive: {
    selected: palette.gold.primary, // Selected navigation background
    navBackground: palette.purple.primary, // Bottom nav background
    avatar: palette.gold.primary, // Avatar background
    qrCode: palette.purple.primary, // QR code color
  },

  // Status colors
  status: {
    notification: palette.red.notification, // Notification dot
  },

  // Border colors
  border: {
    primary: palette.border.light2,
    secondary: palette.border.light1,
    accent: palette.border.accent,
  },

  // Legacy color mappings (for gradual migration)
  legacy: {
    background1: palette.background.light1,
    background2: palette.background.light2,
    background3: palette.background.light3,
    border1: palette.border.light1,
    border2: palette.border.light2,
    text1: palette.purple.primary,
    text2: palette.gold.primary,
    text3: palette.white.pure,
  },
};
